import * as Scrivito from "scrivito";
import {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
} from "../../_defaultFormEditingConfig";
import Option from "../SelectOptionWidget/SelectOptionWidgetClass";

Scrivito.provideEditingConfig("SelectboxWidget", {
  title: "Select",
  attributes: {
    ...defaultFormInputEditingAttributes,
  },
  properties: [...defaultFormInputEditingProperties, "placeholder", "options"],
  initialContent: {
    ...defaultFormInputInitialContent,
    options: [
      new Option({ text: "Option 1" }),
      new Option({ text: "Option 2" }),
    ],
    placeholder: "Bitte auswählen",
  },
  validations: [
    [
      "csvColumnName",
      (csvColumnName) => {
        if (!csvColumnName) {
          return "CSV column name is required";
        }
        return null;
      },
    ],
  ],
});
